import React, { useContext } from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import NavbarSimple from "../components/navbar/NavbarSimple";
import Content from "../components/Content";
import Settings from "../components/Settings";

import docItems from "../components/sidebar/docItems";
import { VideosContext } from "../contexts/VideosContext";

const Doc: React.FC = ({ children }) => {
  const { videos, setVideos } = useContext(VideosContext);
  console.log("video-doc", videos);
  return (
    <React.Fragment>
      <Wrapper>
        <Sidebar items={docItems} showFooter={false} />
        <Main>
          <NavbarSimple />
          <Content>
            {children}
            <Outlet />
          </Content>
        </Main>
      </Wrapper>
      <Settings />
    </React.Fragment>
  );
};
export default Doc;
